// This module defines domains for which sub-link attribution should be suppressed in the UI.
    // Forbidden domains in sub-blocks
    // Will not be rendered as links and will not trigger sub-link attribution logic
const SUPPRESSED_SUB_LINK_DOMAINS = [
  'linktr.ee'
];

const normalizeDomain = (value = '') => String(value || '').trim().toLowerCase();

const matchesConfiguredDomain = (hostname = '') => {
  const normalizedHost = normalizeDomain(hostname);
  if (!normalizedHost) return false;

  return SUPPRESSED_SUB_LINK_DOMAINS.some((domain) => {
    const normalizedDomain = normalizeDomain(domain);
    if (!normalizedDomain) return false;
    return normalizedHost === normalizedDomain || normalizedHost.endsWith(`.${normalizedDomain}`);
  });
};

const extractCandidateUrls = (text = '') => {
  const input = String(text || '');
  const candidates = [];

  const hrefRegex = /href\s*=\s*["']([^"']+)["']/gi;
  let hrefMatch;
  while ((hrefMatch = hrefRegex.exec(input)) !== null) {
    candidates.push(hrefMatch[1]);
  }

  const urlRegex = /https?:\/\/[^\s"'<>]+/gi;
  let urlMatch;
  while ((urlMatch = urlRegex.exec(input)) !== null) {
    candidates.push(urlMatch[0]);
  }

  return candidates;
};

const normalizeCandidateUrl = (value = '') => {
  return String(value || '')
    .trim()
    .replace(/[),;!?]+$/g, '')
    .replace(/\.{3,}$/g, '');
};

export const shouldSuppressSubTextForLinks = (subInnerHtml = '') => {
  const urls = extractCandidateUrls(subInnerHtml);

  for (const rawUrl of urls) {
    try {
      const parsed = new URL(normalizeCandidateUrl(rawUrl));
      if (matchesConfiguredDomain(parsed.hostname)) {
        return true;
      }
    } catch (_error) {
      // Ignore malformed URLs and continue checking the rest.
    }
  }

  return false;
};

export const stripSuppressedSubBlocks = (source = '') => {
  const text = String(source || '');

  const stripClosedSubBlocks = text.replace(/<sub\b[^>]*>([\s\S]*?)<\/sub>/gi, (fullMatch, innerHtml = '') => {
    return shouldSuppressSubTextForLinks(innerHtml) ? '' : fullMatch;
  });

  // Handle truncated previews where a <sub> block may be cut before </sub>.
  return stripClosedSubBlocks.replace(/<sub\b[^>]*>([\s\S]*)$/i, (fullMatch, innerHtml = '') => {
    return shouldSuppressSubTextForLinks(innerHtml) ? '' : fullMatch;
  });
};

export { SUPPRESSED_SUB_LINK_DOMAINS };

export default SUPPRESSED_SUB_LINK_DOMAINS;
